import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted, onBeforeUnmount } from 'vue'
import Icon from '@/components/common/Icon.vue'

// ----- data -----

export default /*#__PURE__*/_defineComponent({
  __name: 'BackToTop',
  setup(__props) {

const isVisible = ref(false)

// ----- methods -----
// 畫面滾動超過 100px 時，顯示按鈕
const handleScroll = () => {
  const positionY = Math.abs((document.getElementById('app') as HTMLBodyElement).scrollTop)

  if (positionY > 100) {
    isVisible.value = true
  } else {
    isVisible.value = false
  }
}

// 回到頂部
const scrollToTop = () => {
  document.getElementById('app')?.scrollTo({ top: 0, behavior: 'smooth' })
}

// ----- lifecycle -----
// 新增滾動事件
onMounted(() => {
  document.getElementById('app')?.addEventListener('scroll', handleScroll)
})

// 移除滾動事件
onBeforeUnmount(() => {
  document.getElementById('app')?.removeEventListener('scroll', handleScroll)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["back-to-top", { active: isVisible.value }]),
    onClick: scrollToTop
  }, [
    _createVNode(Icon, {
      iconName: "back_to_top",
      width: "40px"
    })
  ], 2))
}
}

})